import { render, staticRenderFns } from "./importDialogupab.vue?vue&type=template&id=12ea8fd9"
import script from "./importDialogupab.vue?vue&type=script&lang=js"
export * from "./importDialogupab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports